import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const supportHeadsetIcon = svgToTinyDataUri(
  `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Chat bubble (top left) -->
  <path d="M4 6C4 4.89543 4.89543 4 6 4H16C17.1046 4 18 4.89543 18 6V12C18 13.1046 17.1046 14 16 14H10L6 18V14H6C4.89543 14 4 13.1046 4 12V6Z" fill="#E9D5FF" stroke="#501283" stroke-width="1.5" stroke-linejoin="round"/>
  <circle cx="8" cy="9" r="1.25" fill="#501283"/>
  <circle cx="11" cy="9" r="1.25" fill="#501283"/>
  <circle cx="14" cy="9" r="1.25" fill="#501283"/>

  <!-- Headset band -->
  <path d="M16 24C16 18.4772 20.4772 14 26 14C31.5228 14 36 18.4772 36 24" stroke="#501283" stroke-width="2" stroke-linecap="round"/>

  <!-- Left ear piece -->
  <rect x="14" y="22" width="5" height="10" rx="2.5" fill="#E9D5FF" stroke="#501283" stroke-width="1.5"/>

  <!-- Right ear piece -->
  <rect x="33" y="22" width="5" height="10" rx="2.5" fill="#E9D5FF" stroke="#501283" stroke-width="1.5"/>

  <!-- Microphone arm -->
  <path d="M19 32C19 32 22 32 24 34C26 36 26 38 26 38" stroke="#501283" stroke-width="1.5" stroke-linecap="round"/>
  <circle cx="26" cy="38" r="2" fill="#E9D5FF" stroke="#501283" stroke-width="1.5"/>
</svg>`
);
